<template>
  <div class="layout-page">
    <el-container>
      <el-aside class="layout-sidebar" width="150px">
        <div class="sidebar-header">
          <h2>BPS后台</h2>
        </div>
        <div class="sidebar-main">
          <ul>
            <li><router-link to="/Subscription">订阅管理</router-link></li>
            <li><router-link to="/User">用户管理</router-link></li>
            <li><router-link to="/Brand">品牌信息管理</router-link></li>
            <li v-if="level/1 !== 3"><router-link to="/Search">搜索</router-link></li>
            <li v-if="showbtn"><router-link to="/Supplier">供应商管理</router-link></li>
            <li v-if="showspot"><router-link to="/SpotCheck">数据抽查</router-link></li>
          </ul>
        </div>
      </el-aside>
      <el-container>
        <el-header class="layout-header" height="50px">
          <el-row :gutter="15">
            <el-col :span="12" :offset="12">
              <div class="user-logout" v-if="account == 'david.liu@simplybrand.com'">
                David<el-button type="text" @click="Logout()">退出</el-button>
              </div>
              <div class="user-logout" v-else>
                {{ account }}（{{ userlevel }}）<el-button type="text" @click="Logout()">退出</el-button>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data(){
    return{
      account: '',
      level: '',
      userlevel: '',
      showbtn: false,
      showspot: false
    }
  },

  mounted(){
    this.level = this.getLocalStorage('level')
    this.account = this.getLocalStorage('account')
    this.userlevel = this.getLocalStorage('level')/1 === 1 ? '超级管理员' : this.getLocalStorage('level')/1 === 2 ? '数据管理员' : '一般用户'
    this.showbtn = this.showSupplierLink(this.account)
    this.showspot = this.showspotlink(this.account)
  },

  methods: {
    Logout: function(){
      let that = this
      localStorage.removeItem("token")
      that.$router.push({ path: "/" })
    },

    showSupplierLink: function(account){
      if(window.btoa(account) == 'ZGF2aWQubGl1QHNpbXBseWJyYW5kLmNvbQ==' || 
        window.btoa(account) == 'aHVhbmdodWFuQHNpbXBseWJyYW5kLmNvbQ==' ||
        window.btoa(account) == 'aHVhbmdodWFuQHNpbXBseWJyYW5kLmNvbTE=' ||
        window.btoa(account) == 'a2F1Zm1hbkBzaW1wbHlicmFuZC5jb20=' ||
        window.btoa(account) == 'ZnJhbmsuc2hpQHNpbXBseWJyYW5kLmNvbQ==' ||
        window.btoa(account) == 'eWFuY3kueHVAc2ltcGx5YnJhbmQuY29t' ||
        window.btoa(account) == 'ZnJhbmsuc2hpQHNpbXBseWJyYW5kLmNvbTE=' ||
        window.btoa(account) == 'a2F1Zm1hbkBzaW1wbHlicmFuZC5jb20x'){
        return true
      } else{
        return false
      }
    },

    showspotlink: function(account){
      if(
        account === 'david.liu@simplybrand.com' || account === 'huanghuan@simplybrand.com1' || account === 'circle.tjong@simplybrand.com'
      ){
        return true
      } else{
        return false
      }
    }
  }

}
</script>